<script setup lang="ts">
import type { NavSectionChild } from "~/composables/useContentRoute";

// Renders a flat list of <e-mega-menu-link>s (no column wrapper). Used inside a
// tab that has a single column: the parent <e-mega-menu-tab> flows these links
// into its `columns` (1–3) track count, so one column's items fill the available
// width instead of stacking in a single narrow track.
defineProps<{ items: NavSectionChild[] }>();

const isExternal = (path: string) => isExternalUrl(path);
const { isMuted } = useCanAccess();
</script>

<template>
  <e-mega-menu-link
    v-for="child in items"
    :key="child.slug"
    :to="child.path"
    :icon="isMuted(child.path) ? 'lock' : child.icon || undefined"
    :title="child.title"
    :description="child.description || undefined"
    :target="isExternal(child.path) ? '_blank' : undefined"
    :class="isMuted(child.path) ? 'part-[base]:opacity-60' : undefined"
  ></e-mega-menu-link>
</template>
